import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'

export class DialogueNode extends BaseNode {
    next = NodeType.Shot
    enableSuggestions = false

    static getType(): string {
        return 'dialogue'
    }

    static clone(node: DialogueNode): DialogueNode {
        return new DialogueNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(): HTMLElement {
        const dom = document.createElement('div')
        dom.className = 'dialogue node-style-common avoid-page-break '
        return dom
    }

    static importJSON(jsonNode: SerializedBaseNode): DialogueNode {
        return new DialogueNode(jsonNode.id)
    }

    static importDOM(): null {
        return null
    }
}
